import palette from './palette';

const icon = {
  MuiSvgIcon: {
    defaultProps: {
      color: 'action',
    },
    styleOverrides: {
      colorAction: {
        color: palette.grey[800],
      },
    },
  },
};
export default icon;
